module.exports = __webpack_public_path__ + "img/FisO8RFQT7WDUl5GIgr-4RAK3Tsz.865d519c.svg";